// In all cases except passed, the student answer will be marke incorect
export const RESULT_FETCH_STOP_STATES = ['passed', 'failed', 'timed_out', 'skipped']
export const RESULT_FETCH_INTERVAL = 5000
